import React from 'react';
import { Col, Row } from 'react-bootstrap';

const Skill = () => {
    return (
        <Row md={3} lg={4} sm={2} xs={2} className='justify-content-center align-items-center'>
            <Col>
                <div className="skill-img">
                    <img src="https://i.ibb.co/DV6GPLp/html.png" className='img-fluid' alt="" />
                </div>
            </Col>
            <Col>
                <div className="skill-img">
                    <img src="https://i.ibb.co/d7nVY2p/css3-logo-png-transparent.png" className='img-fluid' alt="" />
                </div>
            </Col>
            <Col>
                <div className="skill-img">
                    <img src="https://i.ibb.co/19PF220/bootstrap-removebg-preview.png" className='img-fluid' alt="" />
                </div>
            </Col>
            <Col>
                <div className="skill-img">
                    <img src="https://i.ibb.co/fHj1r6d/download-removebg-preview1.png" className='img-fluid' alt="" />
                </div>
            </Col>
           
            <Col>
                <div className="skill-img">
                    <img src="https://i.ibb.co/47SMH8m/313-3133777-javascript-transparent-background-svg-hd-png-download-removebg-preview.png" className='img-fluid' alt="" />
                </div>
            </Col>
            <Col>
                <div className="skill-img">
                    <img src="https://i.ibb.co/6JtqfZf/1611079-removebg-preview.png" className='img-fluid' alt="" />
                </div>
            </Col>
            <Col>
                <div className="skill-img">
                    <img src="https://i.ibb.co/Lgwgyj1/102-1024697-related-wallpapers-node-js-logo-png-clipart-removebg-preview.png" className='img-fluid' alt="" />
                </div>
            </Col>
            <Col>
                <div className="skill-img">
                    <img src="https://i.ibb.co/ss2KW7g/kisspng-mongodb-logo-database-nosql-postgresql-how-to-create-an-outstanding-tech-stack-clickup-bl-5c.png" className='img-fluid' alt="" />
                </div>
            </Col>
           
        </Row>
    );
};

export default Skill;